var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-gauge",style:({ height: _vm.styleBindings.height })},[(_vm.value > 0)?_c('div',{staticClass:"lg-position",style:(_vm.styleBindings)}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }